import { render, staticRenderFns } from "./ThanksCount.vue?vue&type=template&id=c18113cc&scoped=true&"
import script from "./ThanksCount.vue?vue&type=script&lang=js&"
export * from "./ThanksCount.vue?vue&type=script&lang=js&"
import style0 from "./ThanksCount.vue?vue&type=style&index=0&id=c18113cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18113cc",
  null
  
)

export default component.exports